import { configureStore } from "@reduxjs/toolkit";
import { hydrateCart } from "./hydrateCart";
import { draftPersister } from "./middleware/draftPersister";
import rootReducer from "./rootReducer";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(draftPersister),
  devTools: process.env.NODE_ENV !== "production",
});

hydrateCart(store);

export default store;
